import ResourceService from './resource.service'

class ClientCountryService extends ResourceService {
  static get resource() {
    return 'client-country'
  }
}

export default ClientCountryService
